// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__95NNa","header":"ClearentDisclaimer_header__2hI6P","inner":"ClearentDisclaimer_inner__tEtH4"};